import { useMediaQuery } from 'react-responsive'

export const DESKTOP = 'DESKTOP'
export const LAPTOP = 'LAPTOP'
export const TABLET = 'TABLET'
export const PHONE = 'PHONE'
export const UNKNOWN = 'UNKNOWN'

export type ScreenSize =
  | typeof DESKTOP
  | typeof LAPTOP
  | typeof TABLET
  | typeof PHONE
  | typeof UNKNOWN

export type ScreenSizeMap = { [key in ScreenSize]: number }

export const baseScreenSizeMap: ScreenSizeMap = {
  [DESKTOP]: 1200,
  [LAPTOP]: 900,
  [TABLET]: 600,
  [PHONE]: 320,
  [UNKNOWN]: 0,
}

/**
 * screenSizeMap defaults to:
 *  [DESKTOP]: 1200,
 *  [LAPTOP]: 900,
 *  [TABLET]: 600,
 *  [PHONE]: 320,
 *  [UNKNOWN]: 0,
 */
export const useScreenSize = (
  screenSizeMap: ScreenSizeMap = baseScreenSizeMap
): ScreenSize => {
  const isDesktop = useMediaQuery({ minWidth: screenSizeMap.DESKTOP })
  const isLaptop = useMediaQuery({ minWidth: screenSizeMap.LAPTOP })
  const isTablet = useMediaQuery({ minWidth: screenSizeMap.TABLET })
  const isPhone = useMediaQuery({ minWidth: screenSizeMap.PHONE })

  switch (true) {
    case isDesktop:
      return DESKTOP
    case isLaptop:
      return LAPTOP
    case isTablet:
      return TABLET
    case isPhone:
      return PHONE
    default:
      return UNKNOWN
  }
}

export const useIsLaptopOrSmallerScreen = () => {
  return useMediaQuery({ maxWidth: 1000 })
}
